module.exports = __webpack_public_path__ + "img/zhiyuanpinggu2.4b522b07.png";